import _classCallCheck from "/codebuild/output/src1015192178/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src1015192178/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src1015192178/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src1015192178/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src1015192178/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
import * as React from 'react';
import FormattedMessage from './message';
import { Context } from './injectIntl';
import { invariantIntlContext } from '../utils';

var FormattedHTMLMessage = /*#__PURE__*/function (_FormattedMessage) {
  _inherits(FormattedHTMLMessage, _FormattedMessage);

  var _super = _createSuper(FormattedHTMLMessage);

  function FormattedHTMLMessage() {
    _classCallCheck(this, FormattedHTMLMessage);

    return _super.apply(this, arguments);
  }

  _createClass(FormattedHTMLMessage, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(Context.Consumer, null, function (intl) {
        if (!_this.props.defaultMessage) {
          invariantIntlContext(intl);
        }

        var formatHTMLMessage = intl.formatHTMLMessage,
            textComponent = intl.textComponent;
        var _this$props = _this.props,
            id = _this$props.id,
            description = _this$props.description,
            defaultMessage = _this$props.defaultMessage,
            rawValues = _this$props.values,
            children = _this$props.children;
        var Component = _this.props.tagName; // This is bc of TS3.3 doesn't recognize `defaultProps`

        if (!Component) {
          Component = textComponent || 'span';
        }

        var descriptor = {
          id: id,
          description: description,
          defaultMessage: defaultMessage
        };
        var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

        if (typeof children === 'function') {
          return children(formattedHTMLMessage);
        } // Since the message presumably has HTML in it, we need to set
        // `innerHTML` in order for it to be rendered and not escaped by React.
        // To be safe, all string prop values were escaped when formatting the
        // message. It is assumed that the message is not UGC, and came from the
        // developer making it more like a template.
        //
        // Note: There's a perf impact of using this component since there's no
        // way for React to do its virtual DOM diffing.


        var html = {
          __html: formattedHTMLMessage
        };
        return React.createElement(Component, {
          dangerouslySetInnerHTML: html
        });
      });
    }
  }]);

  return FormattedHTMLMessage;
}(FormattedMessage);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.defaultProps = Object.assign(Object.assign({}, FormattedMessage.defaultProps), {
  tagName: 'span'
});
export default FormattedHTMLMessage;